import React, { memo, useContext } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { AppContext } from '@prisjakt/ui-app-context';
import { TabAnchor } from '../../../product-tabs/types';
import { PriceHistoryLinkWrapper } from './styles';

type OwnProps = {
  onClick: () => void;
  children: React.ReactNode | null;
};

const LinkToPriceHistoryComponent: React.FC<React.PropsWithChildren<
  React.PropsWithChildren<OwnProps>
>> = ({ children, onClick }) => {
  const { t } = useContext(AppContext);
  const location = useLocation();
  const to = `${location.pathname}${location.search}${TabAnchor.STATISTICS}`;

  return (
    <PriceHistoryLinkWrapper>
      <Link
        to={to}
        onClick={onClick}
        aria-label={t('product', 'tabs.price-history')}
      >
        {children}
      </Link>
    </PriceHistoryLinkWrapper>
  );
};

export const LinkToPriceHistory = memo(LinkToPriceHistoryComponent);
